import axios from "axios";
import AuthenticationFailureHandler from "../utils/AuthenticationFailureHandler";
import { AUTHORIZE_BASE_URL } from "../utils/EmpUtil";
import { is401, is404 } from "../errors/ErrorConstants";

export default class DealerGroupingClient {
  static baseUrl = AUTHORIZE_BASE_URL;

  static getDealerGroup(user, salesCode, page, isFieldUser, paCode) {
    let resourcePath;

    if (paCode) {
      resourcePath = `dealer/${paCode}`;
    } else if (user.market.toUpperCase() === "CAN") {
      resourcePath = `dealer/${user.dealerGroupId}`;
    } else {
      resourcePath = user.generateResourcePath();
    }

    let url = `${this.baseUrl}/${resourcePath}/dealer-group`;
    if (salesCode) {
      url += "?salesCode=" + salesCode;
    }

    if (isFieldUser) {
      url += salesCode ? "&isFieldUser=true" : "?isFieldUser=true";
    }

    if (page) {
      url += salesCode ? "&page=" + page : "?page=" + page;
    }

    return axios
      .get(url)
      .then((response) => {
        return response.data.result.dealerGroupings;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        } else if (is404(error)) {
          throw error;
        } else {
          user.history.push("/error");
        }

        throw error;
      });
  }

  static getDealerInfoCanada(user) {
    const url = `${this.baseUrl}/can/dealer-info`;

    return axios
      .get(url)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        } else {
          user.history.push("/error");
        }
        throw error;
      });
  }
}
